// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import BoardNotificationPreferenceToggle from './BoardNotificationPreferenceToggle';
import SettingsRow from '../../../../../../user/account/accountModal/components/SettingsRow';

// Styles
import './BoardNotificationToggleSettingsRow.scss';

const BoardNotificationToggleSettingsRow = (props) => {
    const { currentBoardId } = props;

    return (
        <SettingsRow className="BoardNotificationToggleSettingsRow" label="Notify me when someone edits this board">
            <BoardNotificationPreferenceToggle currentBoardId={currentBoardId} />
        </SettingsRow>
    );
};

/**
 * For the same reason as the BoardEditorList, we can't update this component while the
 * board editor list is being refreshed.
 */
const areEqual = (prevProps, nextProps) => nextProps.transitioning;

BoardNotificationToggleSettingsRow.propTypes = {
    currentBoardId: PropTypes.string,
};

export default React.memo(BoardNotificationToggleSettingsRow, areEqual);
